import { mapState, mapGetters } from 'vuex'
import { client } from '~/plugins/global.js'
import { gtmEvent } from '~/plugins/global'
import _ from 'lodash'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import OrderSummaryBackorderAlert from '~/components/OrderSummaryBackorderAlert.vue'
import { interpolateDOLStartersSlug } from '~/util/dol-staters-helper'


// import PageUnderConstruction from '~/components/PageUnderConstruction.vue'
export default {
    name: 'OrderSummary',
    components: {
        TranslatableStringComponent,
        OrderSummaryBackorderAlert,
        // PageUnderConstruction
    },
    data() {
        return {
            showHero: false,
            showFooter: true,
            e1: 1,
            tick: false,
            isWebOrderSuccess: true,
            localShippingDetails: null,
            localBillingDetails: null,
            localCartProducts: null,
            localSubTotal: null,
            localTotal: null,
            localShipping: null,
            currentOrder: null,
            currentLineItems: [],
            debug: process.env.DEBUG_ON === 'true',
            coupons: [],
            lineItemsPn: [],
            availableElasticItems: [],
            availabilityDialogBox: false,
            availableItems: [],
            unavailableItems: [],
            showDialogBox: false,
            initialOrder: null,
            showBackOrderItems: false,
            showRemovedItems: false,
            orderArray: null,
            finalOrderList: null,
            finalOrderListCurrentIndex: null,
        }
    },
    watch: {
        $route(newVal, oldVal){
            if(!_.isEqual(newVal.query, oldVal.query))
                location.reload()
        }
    },
    computed: {
        ...mapState('checkout', [
            'webOrderConfirmationNo',
            'customerCreateResponseId',
        ]),
        ...mapGetters({
            cartProducts: 'cart/fetchCartProducts',
            subTotal: 'cart/fetchCartSubtotal',
            total: 'cart/fetchCartTotal',
            shipping: 'cart/fetchSelectedMethodPrice',
            webUser: 'auth/webUser',
        }),

        loadCompletion() {
            if (this.isWebOrderSuccess === true) {
                return 'load-complete load-success'
            } else if (this.isWebOrderSuccess === false) {
                return 'load-complete load-failure'
            } else {
                return ''
            }
        },
        billingDetails() {
            if (this.currentOrder) {
                return {
                    // firstName: this.currentOrder.OrderBillingContact.nameFirst,
                    // lastName: this.currentOrder.OrderBillingContact.nameLast,
                    // company: this.currentOrder.OrderBillingContact.nameCompany,
                    /*eslint-disable */
                    printAs: this.currentOrder.billingContactPrintAs,
                    contactName: this.currentOrder.billingContactName,
                    country: this.currentOrder.billingContactCountry,
                    addressLine1: this.currentOrder.billingContactAddress1,
                    addressLine2: this.currentOrder.billingContactAddress2,
                    city: this.currentOrder.billingContactCity,
                    stateProvince: this.currentOrder.billingContactState,
                    zipPostalCode: this.currentOrder.billingContactPostalCode,
                    // primaryPhoneNo: this.currentOrder.billingContactphone1,
                    primaryEmailAddress: this.currentOrder.billingContactEmail1,
                }
            } else {
                return undefined
            }
        },
        shippingDetails() {
            if (this.currentOrder) {
                return {
                    // firstName: this.currentOrder.OrderShippingContact.nameFirst,
                    // lastName: this.currentOrder.OrderShippingContact.nameLast,
                    // company: this.currentOrder.OrderShippingContact.nameCompany,
                    /*eslint-disable */
                    printAs: this.currentOrder.shippingContactPrintAs,
                    contactName: this.currentOrder.shippingContactName,
                    country: this.currentOrder.shippingContactCountry,
                    addressLine1: this.currentOrder.shippingContactAddress1,
                    addressLine2: this.currentOrder.shippingContactAddress2,
                    city: this.currentOrder.shippingContactCity,
                    stateProvince: this.currentOrder.shippingContactState,
                    zipPostalCode: this.currentOrder.shippingContactPostalCode,
                    // primaryPhoneNo: this.currentOrder.shippingContactphone1,
                    primaryEmailAddress: this.currentOrder
                        .shippingContactEmail1,
                    /* eslint-enable */
                }
            } else {
                return undefined
            }
        },
        cardFailed() {
            return this.initialOrder?.cardFailed
        },
        lineItemDetails() {
            if (this.currentLineItems.length > 0) {
                return this.currentLineItems.map((item) => {
                    return {}
                })
            } else {
                return undefined
            }
        },
        productLineItems() {
            if (this.currentLineItems.length > 0) {
                return this.currentLineItems.filter((item) => {
                    if (
                        item.itemIdentifier === '54000' ||
                        item.itemIdentifier === '3789' ||
                        item.itemIdentifier === '3790' ||
                        item.itemIdentifier === '3814' ||
                        item.itemIdentifier === '3816' ||
                        item.itemIdentifier === '3811' ||
                        item.itemIdentifier === 'Tariff- 25' ||
                        item.itemIdentifier === '53000' ||
                        item.itemIdentifier === 'International Handling Fee' ||
                        item.itemIdentifier === 'International Paperwork' ||
                        item.itemIdentifier === 'EXW' ||
                        item.itemIdentifier === 'WD Handling Fee' ||
                        item.itemIdentifier ===
                            this.couponDetails?.itemIdentifier ||
                        item.orderLineQty === 0
                    ) {
                        return false
                    } else {
                        return true
                    }
                })
            } else {
                return []
            }
        },
        shippingLineItem() {
            if (this.currentLineItems) {
                return this.currentLineItems.find((item) => {
                    if (
                        item.itemIdentifier === '54000' ||
                        item.itemIdentifier === '3814' ||
                        item.itemIdentifier === '3790' ||
                        item.itemIdentifier === '3789' ||
                        item.itemIdentifier === '3816'
                    ) {
                        return item
                    }
                })
            } else {
                return undefined
            }
        },
        shippingOversizePackageLineItemTotal() {
            return (
                this.currentLineItems
                    .filter((f) => f.itemIdentifier === '3811')
                    .reduce((acc, i) => acc + i.orderLineActualPrice, 0) || 0
            )
        },
        tariffAmount() {
            if (this.currentLineItems) {
                return this.currentLineItems.reduce((acc, val) => {
                    return val.itemIdentifier === 'Tariff- 25'
                        ? acc + parseFloat(val.orderLineTotal)
                        : acc
                }, 0)
            } else {
                return undefined
            }
        },
        handlingFee() {
            return (
                this.currentLineItems?.find((item) =>
                    ['53000', 'International Handling Fee'].includes(
                        item.itemIdentifier
                    )
                )?.orderLineActualPrice || 0
            )
        },
        handlingFeePerLineItemSum() {
            if (this.currentLineItems) {
                return this.currentLineItems.reduce((acc, val) => {
                    return val.itemIdentifier === 'WD Handling Fee'
                        ? acc + parseFloat(val.orderLineTotal)
                        : acc
                }, 0)
            } else {
                return 0
            }
        },
        handlingFeeTotal() {
            return this.handlingFee + this.handlingFeePerLineItemSum
        },
        // taxRate() {
        //     if (this.currentOrder && this.currentOrder.tax) {
        //         const parts = this.currentOrder.tax.split('|')
        //         return parts[0]
        //     } else {
        //         return 0
        //     }
        // },
        taxTotal() {
            if (this.currentOrder && this.currentOrder.tax) {
                return this.currentOrder.tax
            } else {
                return 0
            }
        },
        subTotal() {
            if (this.productLineItems.length > 0) {
                return this.productLineItems.reduce((acc, val) => {
                    return acc + parseFloat(val.orderLineTotal)
                }, 0)
            } else {
                return 0
            }
        },
        grandTotal() {
            if (this.currentOrder && this.currentLineItems.length > 0) {
                return (
                    parseFloat(this.subTotal) +
                    parseFloat(this.tariffAmount || 0) +
                    parseFloat(this.handlingFee || 0) +
                    parseFloat(this.handlingFeePerLineItemSum || 0) +
                    parseFloat(
                        this.shippingLineItem
                            ? this.shippingLineItem.orderLineActualPrice
                            : 0
                    ) +
                    parseFloat(this.shippingOversizePackageLineItemTotal) +
                    parseFloat(this.taxTotal ? this.taxTotal : 0) -
                    parseFloat(this.couponDiscountValue)
                ).toFixed(2)
            } else {
                return 0
            }
        },
        carrierVendor() {
            if (this.shippingLineItem) {
                if (this.shippingLineItem.itemIdentifier === '3789') {
                    return `${this.localize('externalShipperLabel')} ${
                        this.externalShippingAccountNumber
                    }`
                } else {
                    return this.localize('internalShipperLabel')
                }
            } else {
                return ''
            }
        },
        couponDetails() {
            if (
                this.currentLineItems.length > 0 &&
                this.couponCodes.length > 0
            ) {
                return this.currentLineItems.find((item) => {
                    return (
                        this.couponCodes.includes(item.itemIdentifier) && item
                    )
                })
            } else {
                return undefined
            }
        },
        couponDiscountValue() {
            return this.couponDetails
                ? -this.couponDetails.orderLineActualPrice
                : 0
        },
        couponCodes() {
            return this.coupons.map((item) => item.code)
        },
        shipVia() {
            return (
                this.currentOrder && this.currentOrder.OrderShippingMethod.name
            )
        },
        isShippingToBeDecided() {
            if (
                this.currentOrder &&
                this.currentLineItems.length > 0 &&
                this.shippingLineItem?.itemIdentifier === '3816'
            ) {
                return true
            } else {
                return false
            }
        },
        externalShippingAccountNumber() {
            return this.currentOrder.shippingAccountNumber
        },
        backorderItems() {
            let removedItems, backorderItems
            const initialLineItems = this.initialOrder?.OrderLine
            if (initialLineItems)
                removedItems = initialLineItems.filter(
                    (item1) =>
                        !this.currentLineItems.some(
                            (item2) =>
                                item2.itemIdentifier === item1.itemIdentifier && item2.orderLineQty !== 0
                        ) && item1?.Item?.type === 'Inventory'
                )
            if (this.finalOrderList?.length > 1 && this.finalOrderList[this.finalOrderListCurrentIndex +1]) {
                backorderItems = this.finalOrderList[this.finalOrderListCurrentIndex +1].childItems[0]?.OrderLine.filter(e => {
                    return removedItems.some(item => item.itemIdentifier === e.itemIdentifier)
                 })
            }
            return backorderItems
        },
        removedItems() {
            let removedConvertedItems, removedItems
            const initialLineItems = this.initialOrder?.OrderLine
            if(initialLineItems)
            removedConvertedItems = initialLineItems.filter(
                (item1) =>
                    !this.currentLineItems.some(
                        (item2) =>
                            item2.itemIdentifier === item1.itemIdentifier
                    ) && item1?.Item?.type === 'Inventory'
            )
            // remove backorder items
            if(removedConvertedItems && this.backorderItems)
            removedItems = removedConvertedItems.filter(
                (item1) =>
                    !this.backorderItems.some(
                        (item2) =>
                            item2.itemIdentifier === item1.itemIdentifier
                    ) && item1?.Item?.type === 'Inventory'
            )
            return removedItems
        },
        orderStatus() {
            if (
                this.currentOrder.workFlowStatus === 'Customer contact required'
            )
                return 'Contact support'
            if (this.currentOrder.docType === 'Sales Invoice') return 'Shipped'
            else if (this.currentOrder.docType === 'Shipper') return 'Shipped'
            else if (this.currentOrder.docType === 'Sales Order')
                return 'Processing'
            else if (this.currentOrder.docType === 'Web Order') return 'Pending'
            else return 'N/A'
        },
        salesOrder() {
            return this.orderArray.filter((o) => {
                return o.docType === 'Sales Order'
            }).length === 1
                ? this.orderArray.filter((o) => {
                      return o.docType === 'Sales Order'
                  })[0]
                : null
        },
        webOrder() {
            return this.orderArray.filter((o) => {
                return o.docType === 'Web Order'
            }).length === 1
                ? this.orderArray.filter((o) => {
                      return o.docType === 'Web Order'
                  })[0]
                : null
        },
        shipper() {
            return this.orderArray.filter((o) => {
                return o.docType === 'Shipper'
            }).length === 1
                ? this.orderArray.filter((o) => {
                      return o.docType === 'Shipper'
                  })[0]
                : null
        },
        salesInvoice() {
            return this.orderArray.filter((o) => {
                return o.docType === 'Sales Invoice'
            }).length === 1
                ? this.orderArray.filter((o) => {
                      return o.docType === 'Sales Invoice'
                  })[0]
                : null
        },
        isDueDatePresent() {
            let temp = this.productLineItems.map((i) => this.isDueDateGreaterThanShippingDate(i))
            return temp.includes(true) && this.currentOrder.docType === 'Sales Order'
        }
    },
    async mounted() {
        if (this.$route.query.orderNo) {
            await this.fetchOrderDetails()
            this.$store.commit('cart/setCustomerCreateResponseId', null)
            await this.fetchAllCoupons()
            this.$emit('setWebOrderConfirmationNo', this.currentOrder.docNo)
            this.fetchLineItems()
            await this.checkAvailabilityInElastic()
        }
        if (this.isWebOrderSuccess === true) {
            this.tick = true
        }
    },
    methods: {
        async fetchAllCoupons() {
            const groq = `*[_type in ["coupon"] ]{...}`
            this.coupons = await client.fetch(groq)
        },
        async fetchOrderDetails() {
            const params = {
                uoid: parseInt(this.$route.query.orderNo),
                CustomerId:
                    this.webUser?.WebUserPrimaryCustomerId ||
                    this.customerCreateResponseId,
            }
            const res = await this.$axios.post('erp-order?method=read', params)
            const orderArrayList = res.data?.orders
            const groupedOrderArray = _.groupBy(orderArrayList, 'boid')
            const groupHeaderList =
                orderArrayList?.length > 0 &&
                orderArrayList
                    .filter((i) => i.docType === 'Sales Order')
                    .sort((a, b) => (a.id < b.id ? -1 : 1))
            // order list grouped according to boid 
            this.finalOrderList =
                groupHeaderList.length > 0
                    ? groupHeaderList?.map((item) => {
                          const childItems = groupedOrderArray[item.boid]
                          return {
                              childItems,
                              boid: item.boid,
                              backOrderDocNo: item.docNo
                          }
                      })
                    : [
                          {
                              childItems: orderArrayList,
                          },
                      ]
            // current sales order group index
            this.finalOrderListCurrentIndex = this.$route.query.boid 
                ? this.finalOrderList.findIndex(
                      (i) => i.boid?.toString() === this.$route.query.boid
                  )
                : 0
            this.orderArray = this.finalOrderList?.[
                this.finalOrderListCurrentIndex
            ]?.childItems   // current sales order group  
            this.initialOrder = this.orderArray[0] // current sales order group initial order
            this.currentOrder = this.orderArray[this.orderArray.length - 1] // current sales order group latest order / opened order
        },
        async fetchLineItems() {
            this.currentLineItems = this.currentOrder.OrderLine
            const initialLineItems = this.initialOrder?.OrderLine
            this.currentLineItems.forEach((li) => {
                const item = initialLineItems.find(
                    (x) => x.itemIdentifier === li.itemIdentifier
                )
                li.initialItemQuantity = item?.orderLineQty
            })
            this.currentLineItems.sort((a, b) =>
                a.orderLineNo > b.orderLineNo ? 1 : -1
            )
            this.lineItemsPn = this.currentLineItems.map(
                (item) => item.itemName
            )
        },
        async checkAvailabilityInElastic() {
            const res = await this.$axios.post('elastic-search', {
                elasticQuery: {
                    size: 999,
                    query: {
                        terms: {
                            pn: this.lineItemsPn,
                        },
                    },
                },
                elasticIndex: 'products-sanity',
            })
            const items = res.data.hits.hits
                .map((item) => item._source)
                .filter((obj, pos, arr) => {
                    // removing duplicate products with same 'pn' number
                    return (
                        arr
                            .map((mapObj) => obj.pn && mapObj.pn)
                            .indexOf(obj.pn) === pos
                    )
                })
            this.availableElasticItems = items.map((item) => {
                return {
                    ...item,
                    isAvailable: true,
                }
            })
        },
        getPartNumber(item) {
            return item.split('=')[0]
        },
        getDescription(item) {
            // console.log(item)
            return item.split(' - ').slice(1).join(' - ')
        },
        reorderItem(mainItem, type) {
            const isFound = this.availableElasticItems.find(
                (item) => item.pn === mainItem.itemName
            )
            if (!isFound) this.availabilityDialogBox = true
            else {
                isFound.sale_price = parseFloat(mainItem.orderLineActualPrice)
                const itemPresentInCart = this.cartProducts.find(
                    (item) => item.pn === isFound.pn
                )
                if (itemPresentInCart) {
                    this.$store.dispatch('cart/setQty', {
                        productObj: itemPresentInCart,
                        qty: parseInt(mainItem.orderLineQty),
                    })
                } else {
                    isFound.prod_quantity = parseInt(mainItem.orderLineQty)
                    this.$store.dispatch('cart/appendCart', [isFound])
                    if (type !== 'fromReorderAll')
                        this.$store.dispatch('cart/updateErpCart')
                }
            }
            this.logGtmEvent(isFound)
        },

        reorderAllItems() {
            this.availableItems = this.productLineItems.filter((item) => {
                return this.availableElasticItems.find(
                    (i) => i.pn === item.itemName
                )
            })
            this.unavailableItems = this.productLineItems.filter((item) => {
                return !this.availableElasticItems.find(
                    (i) => i.pn === item.itemName
                )
            })
            if (this.availableItems.length !== this.productLineItems.length)
                this.showDialogBox = true
            else this.reorderAvailableItems()
        },
        reorderAvailableItems() {
            this.availableItems.forEach((item) =>
                this.reorderItem(item, 'fromReorderAll')
            )
            this.$store.dispatch('cart/updateErpCart')
        },
        proceed() {
            this.reorderAvailableItems()
            this.showDialogBox = false
        },

        goToProduct(partNumber) {
            const item = this.availableElasticItems.find(
                (item) => item.pn === partNumber
            )
            if (item.parent) {
                const path = this.localePath({
                    name: 'products-slug',
                    params: {
                        slug: interpolateDOLStartersSlug(item.parent[this.$i18n.locale].current),
                    },
                })
                this.$router.push({ path: `${path}/${item.pn}/` })
            } else {
                return
            }
        },

        convertToReadabledate(isoDate) {
            return isoDate
                ? new Intl.DateTimeFormat('en-US').format(new Date(isoDate))
                : ''
        },

        isDueDateGreaterThanShippingDate(item) {
            const date1 = new Date(item.dueDate)
            const date2 = new Date(this.currentOrder.shippingDate)
            return date1 > date2
        },

        logGtmEvent(item) {
            gtmEvent({
                gtm: this.$gtm,
                event: 'addToCart',
                eventType: 'click',
                atts: {
                    c3source: 'shop',
                    ecommerce: {
                        currencyCode: 'USD',
                        add: {
                            products: [
                                {
                                    id: item.pn,
                                    name: item.name_en,
                                    price: item.sale_price.toFixed(2),
                                    category:
                                        item.categories && item.categories[0]
                                            ? item.categories[0]
                                            : 'not recorded',
                                    product_id: item.product_id,
                                },
                            ],
                        },
                    },
                },
            })
        },
    },
}
